import React, { createContext, useContext } from 'react';

import useTestCycleSorter from './TestCycleSorter.hook';
import { sortNone } from './TestCycleSorter.util';

export type TestCycleSorterContextValue = ReturnType<typeof useTestCycleSorter>;

export const TestCycleSorterContext =
  createContext<TestCycleSorterContextValue>({
    testCycleSortStrategy: 'none',
    setTestCycleSortStrategy: () => undefined,
    testCycleSortFunction: sortNone,
    isTestCycleSorted: false,
  });

export const useTestCycleSorterContext = (): TestCycleSorterContextValue => {
  const value = useContext(TestCycleSorterContext);

  if (!value) {
    throw new Error('TestCycleSorterContext used outside the provider!');
  }

  return value;
};

type Props = { children: React.ReactNode };

export default function TestCycleSorterProvider({
  children,
}: Props): JSX.Element {
  const testCycleSorter = useTestCycleSorter();

  return (
    <TestCycleSorterContext.Provider value={testCycleSorter}>
      {children}
    </TestCycleSorterContext.Provider>
  );
}
